module.exports = __webpack_public_path__ + "img/IMG_1137.8271d487.png";